import {
    FvBoxPortDataRelationAnchor,
    FvBoxPortDataRelationVersion,
} from 'src/models/anchor-and-version/fv-box-port-data-relation.model';
import { Injectable, inject } from '@angular/core';
import { AnchorAndVersionBaseService } from './anchor-and-version-base.service';
import { AuthService } from '../auth.service';
import { ConfigState } from 'src/store/reducers/config.reducer';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class FvBoxPortDataRelationService extends AnchorAndVersionBaseService<
    FvBoxPortDataRelationAnchor,
    FvBoxPortDataRelationVersion
> {
    protected authService = inject(AuthService);
    protected baseUrl = '/api/fvboxportdatarelation';
    protected http = inject(HttpClient);
    protected store = inject<Store<{ config: ConfigState }>>(Store);
}
